import React from "react";
import { NewNavbar } from "../Pages/NewNavbar";
import WhatYouGainSection from "../Components/UI/WhatYouGainSection";

import gift from "../../../assets/image/gift.png";
import book from "../../../assets/image/booksell.png";
import Footer from "../Footer";
import heroimg from "../../../assets/image/redefining.png";
import claim from "../../../assets/image/booksellicon.png";
import { Link } from "react-router-dom";
import SwitchTab from "../Components/UI/SwtichTabs";
import nameRightImg from "../../../assets/image/Asset 3 (3).png";
const infoCards = [
  {
    title: "Smart Pricing Strategies",
    desc: "Set the right price to attract serious buyers and maximize your return.",
    icon: "/icon3/icon7.png",
  },
  {
    title: "Staging Tips and Tricks",
    desc: "Make your home irresistible with expert presentation advice.",
    icon: "/icon3/Asset 13 (4).png",
  },
  {
    title: "Powerful Marketing",
    desc: "Reach more buyers using innovative, targeted strategies.",
    icon: "/icon3/Asset 12 (2).png",
  },
  {
    title: "Stress-Free Selling Tips",
    desc: "Prepare for showings.",
    icon: "/icon3/Asset 8 (3).png",
  },
  {
    title: "Checklists and Resources",
    desc: "Stay organized with handy tools for every step.",
    icon: "/icon3/Asset 11 (3).png",
  },
  {
    title: "Paperwork Guidance",
    desc: "Keep on top of contracts and documents to avoid delays.",
    icon: "/icon3/Asset 10 (1).png",
  },
  {
    title: "Navigating Offers",
    desc: "Handle multiple offers, negotiate well, and close confidently.",
    icon: "/icon3/Asset 9 (2).png",
  },
];

const tabs = [
  {
    title: `OUR GOAL`,
    fontIcon: "fa-solid fa-bullseye me-2",
    content: (
      <div className="">
        <p className="tab-heading">
          We make selling your home seamless and profitable. Our personalized
          approach helps you:
        </p>
        <ul>
          <li>Maximize value</li>
          <li>Minimize stress</li>
          <li>Close faster, with stronger offers.</li>
        </ul>
      </div>
    ),
  },
  {
    title: " OUR MISSION",
    fontIcon: "fa-regular fa-heart me-2",

    content: (
      <div className="">
        <p className="tab-heading">
          We put you first by redefining real estate — focusing on people, not
          transactions. At Milford, we empower you with the knowledge and tools
          to succeed confidently in any market.
        </p>
        <p className="italic-font">
          "Real estate is about relationships. We guide, never pressure."
        </p>
      </div>
    ),
  },
];

export default function SellWithMilford() {
  return (
    <>
      <NewNavbar buySellActive={false} />
      <div className="hero-banner">
        <img
          src={heroimg}
          className="w-100 img-fluid"
          alt="transform your future"
        />
      </div>

      <section className="dream-section">
        <div className="container">
          <p className="vs-title">Ready to Sell? Start Here</p>
          <p className="vs-desc">
            Not sure where to begin? At Milford Real Estate, we make selling
            simple, strategic, and centered around YOU. We challenge industry
            norms by focusing on what matters most: your success. Download the
            free Seller Guide and get the tools to sell confidently and
            profitably.
          </p>
          <div className="row align-items-center pt-4">
            <div className="col-md-7 col-lg-8">
              <img src={book} className="img-fluid" alt="" />
            </div>
            <div className="col-md-5 col-lg-4">
              <p className="title">Inside the Guide:</p>
              <ul>
                <li>Price it right</li>
                <li>Stage to sell</li>
                <li>Market with impact</li>
                <li>Navigate every offer</li>
              </ul>
            </div>
          </div>
          <div className="position-relative d-flex justify-content-center align-items-center flex-column seller">
            <h3 className="vs-title-2 dream-cta">Ready to dive in?</h3>
            <div className="free-buide-btn d-flex gap-5 justify-content-center ">
              <button className="card-btn">
                <Link to={"/sell/seller-guide/"}>DOWNLOAD YOUR FREE GUIDE</Link>
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Guide section with form start */}
      <section className="container-fluid sell-guide-section ">
        <div className="container buyer-form-section">
          <div className="client-name-section">
            <div className="client-name-area">
              <h3>TONY T.</h3>
              <p>Licensed</p>
              <p>
                Realtor <span> @ </span>{" "}
              </p>
            </div>
            <div className="img-section">
              <img src={nameRightImg} alt="" />
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="img-container">
                <img src="" alt="" />
              </div>
            </div>
            <div className="col-md-12 col-lg-7">
              <p className="rest-text">PARTNERS IN YOUR SALE</p>
              <h1 className="main-heading-buyer">
                Why Choose Milford Real Estate
              </h1>
              <p className="sub-content">
                When you sell with Milford, you get more than a Realtor® – you
                get a partner invested in your success. With
                <b> 1,000+ homes sold </b>
                and a proven track record, our expert team delivers strategy,
                dedication, and results that go beyond expectations.
              </p>
              <SwitchTab tabs={tabs} navItemClass="me-4" />

              <div className="sellers-owner-name">
                <div className="seller-unit me-3">Serving 1500+ Sellers</div>
                <div className="owner-name">
                  KARIE MILFORD | <span>Founder of Milford Real Estate</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Guide section with form end */}
      <WhatYouGainSection
        bookSrc={claim}
        bottomSection={true}
        infoCard={infoCards}
        title={"What You’ll Gain from This Exclusive Guide"}
        subtitle={"PLAN. BUY. SUCCEED."}
        topIcon={gift}
        customClass={"col-lg-3 col-md-6"}
        path={"/sell/seller-guide/"}
        parentClass={"justifiy-content-center"}
      />

      <Footer />
    </>
  );
}
